import script from "./Miniature.vue?vue&type=script&setup=true&lang=js"
export * from "./Miniature.vue?vue&type=script&setup=true&lang=js"

import "./Miniature.vue?vue&type=style&index=0&id=2d9f324c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9f324c"]])

export default __exports__